import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUser } from "../../features/userSlice";
import Logo from "../Logo";

function TranslateHeader() {
  const user = useSelector(selectUser);

  return (
    <div className="md:shadow-lg shadow-xl bg-white dark:bg-[#181818] dark:text-white px-5 overflow-hidden sm:h-[100px] rounded-b-lg sm:w-full sticky">
      <div className="items-center sm:pt-4 flex sm:justify-between sm:mr-5 mr-2 pt-2">
        <div>
          <Logo />
        </div>
        <div className="hidden md:block">
          <div className="flex space-x-6 relative">
            <Link to="/">
              <button className="text-[18px] font-sans border text-[#2A71E8] dark:text-white px-[23px] font-bold rounded-[20px] py-[2px] border-[#cfcfcf] dark:border-gray-600">
                HOME
              </button>
            </Link>
            <Link to="/input">
              <button className="text-[18px] font-sans border text-[#2A71E8] dark:text-white px-[23px] font-bold rounded-[20px] py-[2px] border-[#cfcfcf] dark:border-gray-600">
              REVERSE INTERPRETATION
              </button>
            </Link>
            <div>
              <h2 className="flex font-sans">
                Hello,
                <span>
                  <img
                    src={require("../../assets/img/hand.png")}
                    alt=""
                    className="w-4 h-4"
                  />
                </span>
              </h2>
              <h2 className="font-bold font-sans">{user?.email}</h2>
            </div>
            <Link to="/settings/profile">
              <img
                src={require("../../assets/img/profile.png")}
                alt=""
                className="cursor-pointer w-10 h-10"
              />
            </Link>
          </div>
        </div>

        <div className="md:hidden">
          <Link to="/settings/profile">
            <img
              src={require("../../assets/img/profile.png")}
              alt=""
              className="ml-11 w-[60px] h-[60px]"
            />
          </Link>
        </div>
      </div>
      <div className="md:hidden">
        <h3 className="font-sans text-[20px] font-semibold flex">
          Hello3,
          <span>
            <img
              src={require("../../assets/img/hand.png")}
              alt=""
              className="w-7 h-7"
            />
          </span>
        </h3>
        <h3 className="font-sans text-[20px] font-bold">{user?.email}</h3>
      </div>
    </div>
  );
}

export default TranslateHeader;
